import { bl_pos_customer_view_attachment_RowClass } from '../../../dbschema/bl_pos_customer_view_attachment.model';
import {BaseContainerModel} from '../../base-container.model';


export class PosCustomerViewAttachmentContainerModel extends BaseContainerModel {
  bl_pos_customer_view_attachment: bl_pos_customer_view_attachment_RowClass = new bl_pos_customer_view_attachment_RowClass();
}
